module.exports = __webpack_public_path__ + "static/classlist-2b9bc5fb335443f23887ffb612f475d2.png";